/* @flow */
import invariant from 'invariant';
import * as React from 'react';

import CurrentUser from 'auth/CurrentUser';
import Group from 'entities/Group';
import Message from 'entities/Message';
import ChatMessage from 'entities/ChatMessage';
import AnnouncementMessageItem from 'chat/components/AnnouncementMessageItem';

import MessageViewTracker from 'components/MessageViewTracker';
import getChatUuid from 'utils/getChatUuid';

import './styles/AnnouncementMessageListItem.scss';

type Props = {
  group: ?Group,
  subgroupRole?: ?string,
  messages: $ReadOnlyArray<Message | ChatMessage>,
  isGroupChat: ?boolean,
  disableReactionToggle?: boolean,
  showProfilePic: boolean,
  showMetadata?: boolean,
};

// Deprecated: see /Stream/components/.../AnnouncementStream for newest version.
// Only used in the PeopleListGroupProfile and the admin overview tab, to display
// recent announcements.
class AnnouncementMessageListItem extends React.PureComponent<Props> {
  getSender() {
    const { messages } = this.props;
    const firstMessage = messages[0];
    const sender = firstMessage.getSender();
    invariant(sender, 'missing sender in AnnouncementMessageListItem');
    return sender;
  }

  sentByCurrentUser() {
    return CurrentUser.getUserUuid() === this.getSender().getUuid();
  }

  renderMessage(message: Message | ChatMessage, lastOfGroup: boolean, showMetadata: boolean) {
    const { group, subgroupRole, showProfilePic, disableReactionToggle, isGroupChat } = this.props;
    const sender = this.getSender();
    const chatUuid = getChatUuid(message, group, subgroupRole);
    const messageUuid = message.getUuid();

    return (
      <MessageViewTracker
        key={messageUuid}
        messageUuid={messageUuid}
        chatUuid={chatUuid}
        isBroadcast>
        <AnnouncementMessageItem
          message={message}
          group={group || message.getGroupSummary()}
          subgroupRole={subgroupRole}
          senderInitials={sender.getInitials()}
          lastOfGroup={lastOfGroup}
          showProfilePic={showProfilePic}
          disableReactionToggle={disableReactionToggle}
          isGroupChat={isGroupChat || false}
          showMetadata={showMetadata}
        />
      </MessageViewTracker>
    );
  }

  renderContent() {
    const { messages, showMetadata } = this.props;
    const messageItems = messages.map((message, idx) => {
      const lastOfGroup = idx === messages.length - 1;
      const firstOfGroup = idx === 0;
      return this.renderMessage(message, lastOfGroup, showMetadata || firstOfGroup);
    });

    return (
      <div className="AnnouncementMessageListItem-messageGroup">
        <div className="AnnouncementMessageListItem-contentWrap">
          <span className="AnnouncementMessageListItem-content">{messageItems}</span>
        </div>
      </div>
    );
  }

  render() {
    return (
      <li className="AnnouncementMessageListItem AnnouncementMessageListItem-other">
        {this.renderContent()}
      </li>
    );
  }
}

export default AnnouncementMessageListItem;
